// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_D_g","cls2":"Base-cls2_Dub Base-cls1_D_g"};